import {ThreadGroupVariant} from './util/classify-thread'
import {useUnresolvedThreadGroups} from './data/use-unresolved-threads'
import {ForYouThreadItem} from './thread-comments/ForYouThreadItem'

export function YourComments() {
  const {'you-commented': youCommented, 'you-replied': youReplied} = useUnresolvedThreadGroups()

  return (
    <>
      {youReplied.map(thread => (
        <ForYouThreadItem thread={thread} variant={ThreadGroupVariant.YouReplied} key={thread.id} />
      ))}
      {youCommented.map(thread => (
        <ForYouThreadItem thread={thread} variant={ThreadGroupVariant.YouCommented} key={thread.id} />
      ))}
    </>
  )
}
